import clsx from 'clsx';

type Props = {
  isVertical?: boolean;
  /**
   * Based on Tailwind className
   * @see https://tailwindcss.com/docs/height
   */
  height?: string;
  variant?: 'light' | 'dark';
};

export const Divider = ({ isVertical, height, variant = 'light' }: Props) => {
  return (
    <div
      className={clsx(
        variant === 'light' ? 'bg-gray-200' : 'bg-gray-300',
        isVertical ? 'h-5 w-px' : 'h-px w-full',
        height,
      )}
    />
  );
};
